export default "__VITE_ASSET__7fYShwzC__"